import React from 'react';
import {SchoolTypesState, ENABLE_EVENT} from '../../schoolTypes/state';
import {ToggleGroup} from '../../components/togglegroup/index';
import { connect } from 'react-redux';

class Types extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			schoolTypes: SchoolTypesState.get(),
			activeTypes: SchoolTypesState.activeGroups, //array
		}

		this.activeTypesHandler = this.activeTypesHandler.bind(this);
	}

	activeTypesHandler() {

		this.setState({
			schoolTypes: SchoolTypesState.get(),
			activeTypes: SchoolTypesState.activeGroups
		});
	}

	componentDidMount() {

		SchoolTypesState.on('activeGroupsChange', this.activeTypesHandler);

		SchoolTypesState.on(ENABLE_EVENT, this.activeTypesHandler);

		SchoolTypesState.on('change', this.activeTypesHandler);

	}

	componentWillUnmount() {

		SchoolTypesState.removeListener('activeGroupsChange', this.activeTypesHandler);

		SchoolTypesState.removeListener(ENABLE_EVENT, this.activeTypesHandler);

		SchoolTypesState.removeListener('change', this.activeTypesHandler);
	}

	toggleHandler(id, type) {
		
		var ctrlPressed = true;

		SchoolTypesState.toggleFilterGroup(id);

	/*	if(ctrlPressed){
			var activeGroupsNew = SchoolTypesState.activeGroups.slice();
		} else {
			var activeGroupsNew = [];
		}

		console.log('id, type', id, type);
		console.log('activeGroupsNew', activeGroupsNew);

		activeGroupsNew.push(id);

		SchoolTypesState.setActiveGroups(activeGroupsNew); */
	}
	isActive(value) {

		for (var i = this.state.activeTypes.length - 1; i >= 0; i--) {
			if(this.state.activeTypes[i] === value) {
				return true;
			}
		}

		return false;
	}
	render() {

		console.log('SchoolTypesState', SchoolTypesState);
		console.log('this', this);

		var schoolTypes = [];
		for (var i = this.state.schoolTypes.length - 1; i >= 0; i--) {
			var school = this.state.schoolTypes[i];
			schoolTypes.push({id: school.id, group: 'schools', name: school.name, childs:[],
				active: this.isActive(school.id)
			});
		}

		console.log('schoolTypes', schoolTypes);

		return (<ToggleGroup
			clickItemHandler={this.toggleHandler.bind(this)} 
			menuItems={schoolTypes}
			name="Skolas pēc veida"
		/>);
	}
}

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickItem: () => {
      
    }
  }
}

const mapStateToPropsRes = (state) => {

  return {
    padding: state.map.padding
  }
}

const MenuSection = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(Types);

export default MenuSection;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/filters/types/container.js